/*!
 * hash160.js - Hash160 implementation for bcrypto
 * Copyright (c) 2017-2018, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcrypto
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var assert = require('bsert');

var SHA256 = require('./sha256');

var RIPEMD160 = require('./ripemd160');

var HMAC = require('../internal/hmac');

var rmd = new RIPEMD160();
/**
 * Hash160
 */

var Hash160 = /*#__PURE__*/function () {
  function Hash160() {
    _classCallCheck(this, Hash160);

    this.ctx = new SHA256();
  }

  _createClass(Hash160, [{
    key: "init",
    value: function init() {
      this.ctx.init();
      return this;
    }
  }, {
    key: "update",
    value: function update(data) {
      this.ctx.update(data);
      return this;
    }
  }, {
    key: "final",
    value: function final() {
      var out = Buffer.allocUnsafe(32);

      this.ctx._final(out);

      rmd.init();
      rmd.update(out);

      rmd._final(out);

      return out.slice(0, 20);
    }
  }], [{
    key: "hash",
    value: function hash() {
      return new Hash160();
    }
  }, {
    key: "hmac",
    value: function hmac() {
      return new HMAC(Hash160, 64);
    }
  }, {
    key: "digest",
    value: function digest(data) {
      return Hash160.ctx.init().update(data).final();
    }
  }, {
    key: "root",
    value: function root(left, right) {
      assert(Buffer.isBuffer(left) && left.length === 20);
      assert(Buffer.isBuffer(right) && right.length === 20);
      return Hash160.ctx.init().update(left).update(right).final();
    }
  }, {
    key: "multi",
    value: function multi(x, y, z) {
      var ctx = Hash160.ctx;
      ctx.init();
      ctx.update(x);
      ctx.update(y);
      if (z) ctx.update(z);
      return ctx.final();
    }
  }, {
    key: "mac",
    value: function mac(data, key) {
      return Hash160.hmac().init(key).update(data).final();
    }
  }]);

  return Hash160;
}();

Hash160.native = 0;
Hash160.id = 'HASH160';
Hash160.size = 20;
Hash160.bits = 160;
Hash160.blockSize = 64;
Hash160.zero = Buffer.alloc(20, 0x00);
Hash160.ctx = new Hash160();
/*
 * Expose
 */

module.exports = Hash160;